import { Caption, CustomLink, styled, ThemeProps } from '@teko/ds-desktop';
import {
  useFeatureFlags,
  useGlobalData,
  useProductDetailState,
} from 'contexts';
import { t } from 'i18n';
import React from 'react';

const ProductBrand = ({
  brandCode,
  brandName,
}: {
  brandCode: string;
  brandName: string;
}) => {
  return (
    <CustomLink
      href={{
        pathname: '/brands/[brandId]',
        query: {
          brandId: brandCode,
        },
      }}
      as={{
        pathname: `/${brandCode}-brand.${brandCode}`,
      }}
    >
      <Brand>{brandName}</Brand>
    </CustomLink>
  );
};

export const ProductHeader: React.FC = () => {
  const { product } = useProductDetailState();
  const { isDisplayUom } = useGlobalData();
  const { flags } = useFeatureFlags();
  const brandCode = product?.brand?.code;

  const renderBrand = () => {
    const brands = product?.brands || [];
    if (flags.epic_omni_1552 && brands.length > 0) {
      return brands.map((brand, index) => {
        return (
          <React.Fragment key={`${brand.code}${brand.name}${index}`}>
            <ProductBrand brandCode={brand.code} brandName={brand.name} />
            {index + 1 !== product?.brands?.length && ',\xa0'}
          </React.Fragment>
        );
      });
    }
    if (!brandCode || brandCode === 'no-brand')
      return <Brand>{product?.brand?.name}</Brand>;
    return brandCode && product?.brand?.name ? (
      <ProductBrand brandCode={brandCode} brandName={product?.brand?.name} />
    ) : null;
  };
  return (
    <div>
      <Title>{product?.displayName || product?.name}</Title>
      <div>
        <Caption
          level={1}
          weight="regular"
          color="textSecondary"
          style={{ fontSize: '14px', marginTop: '-4px', lineHeight: '1.25rem' }}
        >
          {t('Thương hiệu')}
          {'\xa0'} {renderBrand()}
          <Divider /> SKU: {product?.sellerSku || product?.sku}
        </Caption>
      </div>

      {isDisplayUom && !!product?.uomName ? (
        <Caption
          level={1}
          weight="regular"
          color="textSecondary"
          style={{ fontSize: '14px', margin: '16px 0' }}
        >
          {t('Đơn vị tính')}: {product.uomName}
        </Caption>
      ) : null}
    </div>
  );
};

const Title = styled.h1`
  font-size: 24px;
  line-height: 1.33;
  margin-bottom: 8px;
`;

const Divider = styled.span`
  ::before {
    content: '|';
    margin: 0 8px;
  }
`;

const Brand = styled.span(
  ({ theme }: ThemeProps) => `
  color: ${theme?.colors.primary500};
  &:hover{
    color: ${theme?.colors.primary700};
  }
  `,
);
